import { Product } from '../../@types/wishlist.js';
import {ProductFamilyProduct} from '../../templates/components/product-family/product-family.js';

export class ProductIdentifier {
  readonly id: string;

  private constructor(id: string) {
    this.id = id;
  }

  equalsId(other?: string) {
    return other === this.id;
  }

  equalsProductIdentifier(other: ProductIdentifier) {
    return other.id === this.id;
  }

  static createByProduct(product?: Product | null): ProductIdentifier {
    return ProductIdentifier.create(product?.syan, product?.colorId);
  }

  static createByProductFamilyProduct(productFamilyProduct?: ProductFamilyProduct): ProductIdentifier {
    return ProductIdentifier.of(productFamilyProduct?.code, productFamilyProduct?.color);
  }

  static create(syan?: number, colorId?: string): ProductIdentifier {
    return ProductIdentifier.of(`${syan}`, colorId);
  }

  private static of(syan?: string, colorId?: string): ProductIdentifier {
    return new ProductIdentifier([syan, colorId].filter(e => !!e).join('-'));
  }
}
